const Weather = (props: any) => {
  const { temperature, icon } = props;
  const weatherTemp = temperature || "--";
  const weatherIcon = icon || "";

  return (
    <div className="weather up">
      <span className={`wi ${weatherIcon}`}></span> {weatherTemp}º
    </div>
  );
};

export default Weather;
